import   Style  		    from "components/UI/main.module.scss";
import React, { useState } 		from 'react';
import { BtnCloseAction }	from "components/Buttons/Close/BtnClose";

// This will manage the modal state globally
let showSideContentCallback     = null;
let hideSideContentCallback     = null;

export const useSideContent     = () => {
  
    const showSideContent = (...args) => {
        if (typeof showSideContentCallback  === "function") {
            showSideContentCallback(...args);
        }
    };

    const hideSideContent = () => {
        if (typeof hideSideContentCallback  === "function") {
            hideSideContentCallback();
        }
    };

    return { showSideContent, hideSideContent };
};

export const SideContent        = () => {
    const [isOpen,          setIsOpen       ]   = useState(false);  // slide animation
    const [isSliding,       setIsSliding    ]   = useState(false);
  	const [body,            setBody         ]   = useState(null);
  	const [confirmAction,   setConfirmAction]   = useState(() => () => {}); // Store confirm callback
    const [overlay,         setOverlay      ]   = useState(true);

    const customClass = [
        isOpen ? Style.side_content_expanded : Style.side_content_retracted,
        isSliding ? Style.side_content_slide_in : Style.side_content_slide_out,
    ].join(" ");

    const customStyle = (overlay && isOpen) ? { width: "100%", background: "rgba(0, 0, 0, 0.5)", backdropFilter: "blur(2px)" } : {};

    showSideContentCallback = ({children, confirmAction = null,overlay = true}) => {
        setBody(children);
        setConfirmAction(() => confirmAction);
        setOverlay(overlay);
        setIsOpen(true);

        requestAnimationFrame(() => {
            setIsSliding(true);
        });
    };

    hideSideContentCallback = () => {
        setIsSliding(false);

        setTimeout(() => {
            setIsOpen(false);
            setBody(null);
        }, 300);
    };

    const close = () => {
        hideSideContentCallback();
    };

    return (
        body && (
            <div style={customStyle} className={Style.side_content}>
                <div className={customClass}>
                    <div className={Style.row}>
                        <div className={Style.col}>
                            <div className={[Style.text_end, Style.p_3].join(" ")}>
                                {<BtnCloseAction click_action={close}/>}
                            </div>
                        </div>
                    </div>
                    <div style={{height: '80h'}} className={[Style.overflow_y_auto].join(" ")}>
                        {body}
                    </div>
                </div>
            </div>
        )
    );
};

